import {jsx as _jsx} from "react/jsx-runtime";
import {cn} from '../cn'

const FormatQuote = ({className, ...props}) => (
  _jsx('svg', {
    viewBox: "0 0 24 24"   ,
    'aria-hidden': "true",
    focusable: "false",
    ...props,
    className: cn(
      'inline-block h-[1em] w-[1em] shrink-0 select-none fill-current text-[24px]',
      className
    ),
 children: 
    _jsx('path', { d: "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"  ,} )
  })
)

export default FormatQuote
